import {changeEvent, clickEvent, customDocumentEvent, mouseEnterEvent} from "../../../webpack/modules/events";
import {showPopup} from "../../../webpack/modules-optimized/up-selling-personalized-text";
import {hideModal} from "../../../webpack/modules-optimized/modal";
import {
    changeSliderSlideVisible,
    initImageSlider,
    updatePriceElements
} from "../../../webpack/modules-optimized/product-page";
import {
    hideImageSliderLoader,
    showImageSliderLoader
} from "../../../webpack/modules-optimized/product-page-ui";
import {post} from "../../../webpack/modules/ajax";
import {showModal} from "../../../webpack/modules-optimized/modal";
import {isDesktop} from "../../../webpack/modules/devices";

mouseEnterEvent('#product-page input#checkbox-up-selling-personalized-text', false,  function (checkbox) {
    import(/* webpackChunkName: "popup-personalized-text" */ '../../PopupPersonalizedText/main');
});

changeEvent('#product-page input#checkbox-up-selling-personalized-text', false, async function (checkbox) {
    await import(/* webpackChunkName: "popup-personalized-text" */ '../../PopupPersonalizedText/main');
    if (checkbox.checked) {
        checkbox.checked = false;
        showPopup();
    } else {
        checkbox.value = '';
        checkbox.dataset.width = '';
        checkbox.dataset.height = '';
        checkbox.dataset.text = '';
        checkbox.dataset.font = '';
        checkbox.dataset.color = '';
        checkbox.dataset.mirrored = '';
        checkbox.dataset.rightToLeft = '';
        checkbox.dataset.svg = '';
        checkbox.dataset.price = '';
        document.querySelector('.up-selling-personalized-text .added-personalized-text').classList.add('d-none');
        document.querySelector('.up-selling-personalized-text .edit-personalized-text').classList.add('d-none');
        document.querySelector('.up-selling-personalized-text .no-added-personalized-text').classList.remove('d-none');
        showImageSliderLoader();
        await updateImageSlider();
        hideImageSliderLoader();
    }
});

clickEvent('#product-page .edit-personalized-text', false, function() {
    showModal('personalized-text-pop-up');
});

customDocumentEvent('upSellingPersonalizedTextAddToCart', async function (event) {
    let container = document.getElementById('product-page');
    let checkbox = document.querySelector('#product-page input#checkbox-up-selling-personalized-text');

    checkbox.checked = true;
    checkbox.value = event.detail.productId;
    checkbox.dataset.width = event.detail.width;
    checkbox.dataset.height = event.detail.height;
    checkbox.dataset.text = event.detail.text;
    checkbox.dataset.font = event.detail.font;
    checkbox.dataset.color = event.detail.color;
    checkbox.dataset.mirrored = event.detail.mirrored;
    checkbox.dataset.rightToLeft = event.detail.rightToLeft;
    checkbox.dataset.price = event.detail.price;
    checkbox.dataset.fontFile = event.detail.fontFile;
    checkbox.dataset.colorHex = event.detail.colorHex;
    hideModal('personalized-text-pop-up');
    container.querySelector('.up-selling-personalized-text .personalized-text').innerHTML = event.detail.text;
    container.querySelector('.up-selling-personalized-text .price').innerHTML = event.detail.price;
    container.querySelector('.up-selling-personalized-text .no-added-personalized-text').classList.add('d-none');
    container.querySelector('.up-selling-personalized-text .added-personalized-text').classList.remove('d-none');
    container.querySelector('.up-selling-personalized-text .edit-personalized-text').classList.remove('d-none');

    updatePriceElements(container);
    showImageSliderLoader();
    await updateImageSlider(
        {
            text: event.detail.text,
            fontFile: event.detail.fontFile,
            color: event.detail.colorHex,
            rightToLeft: event.detail.rightToLeft
        },
        event.detail.mirrored
    );
    hideImageSliderLoader();
    if (!isDesktop()) changeSliderSlideVisible(document.querySelectorAll('#product-page .image-slider .product-gallery__slide, #product-page .image-slider .embla-slide').length - 1);
});

function updateImageSlider(generateTextData = {}, isMirrored = false)
{
    return new Promise(resolve => {
        let container = document.querySelector('#product-page');
        let defaultPrice = document.querySelector('.add-item-wish-list');
        let exclusivePremium = document.getElementById('exclusivePremium').value;
        let isArProduct = document.getElementById('isArProduct').value;
        let richCard = document.querySelector('script[type="application/ld+json"]');
        let productType = '-';

        if (richCard) {
            let jsonld = JSON.parse(richCard.innerText);
            productType = (jsonld ? jsonld.category || '' : '').toLowerCase();
        }

        post(
            '/ajax/website/product/get-image-slider',
            {
                id: container.dataset.productId,
                price: defaultPrice.dataset.productPrice,
                mirrored: isMirrored,
                generateText: generateTextData,
                exclusivePremium: exclusivePremium,
                isArProduct: isArProduct
            },
            function (response) {
                let image = container.querySelector('.image');
                image.innerHTML = response.view;
                if (!isDesktop()) initImageSlider(document.querySelector('main.product .image-slider'), productType);
                resolve();
            }
        );
    });
}